const steps = [
  { number: '01', icon: 'ri-message-3-line', title: 'Send Your Inquiry', desc: 'Tell us what you need — product, quantity, and your port. Use our quote form, email, or WhatsApp.', color: '#0a2342' },
  { number: '02', icon: 'ri-price-tag-3-line', title: 'Get Your Quote', desc: 'We find the best price from our trusted mills and send you a full price quote within 2 hours — including the cost to get it to your port.', color: '#0a2342' },
  { number: '03', icon: 'ri-bank-card-line', title: 'Confirm & Pay Deposit', desc: 'Confirm your order and pay a 30% deposit by bank transfer or letter of credit. We start your order right away.', color: '#0a2342' },
  { number: '04', icon: 'ri-search-eye-line', title: 'We Check & Pack', desc: 'We inspect your steel at the mill and prepare all your shipping documents — quality certificates, packing list, and proof of origin — before it leaves.', color: '#0a2342' },
  { number: '05', icon: 'ri-ship-line', title: 'Ship & Track', desc: 'Your steel ships from China. We send you the tracking info so you can follow it all the way to your port.', color: '#0a2342' },
];

export default function HowItWorks() {
  return (
    <section className="py-20 bg-gray-900 overflow-hidden">
      <div className="max-w-[1420px] mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-xs font-black tracking-widest uppercase" style={{ color: '#7eb8f7' }}>Simple Process</span>
          <h2 className="text-3xl md:text-4xl font-black text-white mt-2 mb-3">How It Works</h2>
          <p className="text-gray-400 text-sm max-w-xl mx-auto">
            Ordering steel from China is easy. Here&apos;s what happens from your first message to delivery at your port.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line (desktop only) */}
          <div className="hidden lg:block absolute top-10 left-[10%] right-[10%] h-0.5" style={{ backgroundColor: 'rgba(30,95,168,0.3)' }} />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
            {steps.map((step, i) => (
              <div key={step.number} className="relative flex flex-col items-center text-center group">
                {/* Mobile connector */}
                {i < steps.length - 1 && (
                  <div className="lg:hidden absolute left-1/2 -translate-x-1/2 top-[72px] w-0.5 h-8" style={{ backgroundColor: 'rgba(30,95,168,0.3)' }} />
                )}

                {/* Icon circle */}
                <div className="relative z-10 w-20 h-20 flex items-center justify-center bg-gray-800 rounded-full mb-4 transition-colors border-2" style={{ borderColor: 'rgba(30,95,168,0.4)' }}>
                  <i className={`${step.icon} text-2xl`} style={{ color: '#7eb8f7' }} />
                  <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center text-white text-xs font-black rounded-full" style={{ backgroundColor: '#0a2342' }}>
                    {i + 1}
                  </span>
                </div>

                <h3 className="text-white font-black text-sm mb-2">{step.title}</h3>
                <p className="text-gray-400 text-xs leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-14 text-center">
          <p className="text-gray-400 text-sm mb-5">Ready to start? It takes less than 2 minutes to send your first inquiry.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://wa.me/8617671262710"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-7 py-3 bg-green-500 text-white font-black rounded-md text-sm hover:bg-green-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-base" /> Start on WhatsApp
            </a>
            <a
              href="/contact"
              className="flex items-center justify-center gap-2 px-7 py-3 text-white font-black rounded-md text-sm transition-colors whitespace-nowrap"
              style={{ backgroundColor: '#0a2342' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = '#0d2d56'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = '#0a2342'; }}
            >
              <i className="ri-mail-send-line text-base" /> Send an Inquiry
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
